import React from 'react';
import { Table, Typography } from 'antd';
import { stringMixin } from "../../../utils/strings";
import DeltaLine from "../../../charts/DeltaLine";
const SectorDeviationTable = ({ deviations }) => {
  // Find the min and max delta values to normalize the deltas
  const minDelta = Math.min(...deviations.map(d => d.delta));
  const maxDelta = Math.max(...deviations.map(d => d.delta));

  const columns = [
    {
      title: 'Sector',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <span>{stringMixin.fmt(text)}</span>,
    },
    {
      title: 'Original',
      dataIndex: 'originalWeight',
      key: 'originalWeight',
      render: (originalWeight) => `${(originalWeight * 100).toFixed(2)}%`,
    },
    {
      title: 'New',
      dataIndex: 'newWeight',
      key: 'newWeight',
      render: (newWeight) => <span style={{ color: 'var(--blue)' }}>{(newWeight * 100).toFixed(2)}%</span>,
    },
    {
      title: 'Delta',
      dataIndex: 'delta',
      key: 'delta',
      render: (delta) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <DeltaLine delta={delta} minDelta={minDelta} maxDelta={maxDelta} />  {/* Add the DeltaLine component */}
          <span style={{ marginLeft: 8, color: delta > 0 ? 'var(--green)' : 'var(--red)' }}>
            {delta > 0 ? `+${stringMixin.pct(delta, { prec: 1 })}` : stringMixin.pct(delta, { prec: 1 })}
          </span>
        </div>
      ),
      width: 180
    },
  ];

  const sortedDeviations = deviations.sort((a, b) => b.newWeight - a.newWeight);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <Table
        dataSource={sortedDeviations}
        columns={columns}
        rowKey="name"
        bordered={true}
        size={'middle'}
        className={'striped'}
        pagination={false}
      />
    </div>
  );
};

export default SectorDeviationTable;
